module.exports = __webpack_public_path__ + "static/media/16.f92b06ff.png";